import { lazy } from 'react';

const Landing = lazy(() => import('../pages/Landing'));
const Login = lazy(() => import('../pages/Login'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const ProcedureDemo = lazy(() => import('../pages/ProcedureDemo'));
const ProcedureDetail = lazy(() => import('../pages/ProcedureDetail'));
const ESDProcedureDetail = lazy(() => import('../pages/esd-demo/ESDProcedureDetail'));
const About = lazy(() => import('../pages/About'));
const Search = lazy(() => import('../pages/Search'));
const ClinicalReportSummary = lazy(() => import('../pages/ClinicalReportSummary'));
const ProcedureSummary = lazy(() => import('../pages/ProcedureSummary'));
const ProcedureCompact = lazy(() => import('../pages/ProcedureCompact'));
const ProcedureCompactDemo = lazy(() => import('../pages/ProcedureCompactDemo'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ProcedureTimelineEdit = lazy(() => import('../pages/ProcedureTimelineEdit'));
const PolypCountEdit = lazy(() => import('../pages/PolypCountEdit'));

const HospitalDetail = lazy(() => import('../pages/HospitalDetail'));
const InstallationDetail = lazy(() => import('../pages/InstallationDetail'));
const AccountSettings = lazy(() => import('../pages/AccountSettings'));
const GGPatientReport = lazy(() => import('../pages/GGPatientReport'));
const CatUploadList = lazy(() => import('../pages/CatUploadList'));
const PageAppRedirect = lazy(() => import('../pages/PageAppRedirect'));
const ForbiddenApp = lazy(() => import('../pages/ForbiddenApp'));
const PerformanceEdit = lazy(() => import('../pages/PerformanceEdit'));
const ProcedureCAQ = lazy(() => import('../pages/ProcedureCAQ'));
const ProcedurePerformanceSearch = lazy(() => import('../pages/ProcedurePerformanceSearch'));
const AceDashboards = lazy(() => import('../pages/AceDashboards'));
const CaseAssessment = lazy(() => import('../pages/CaseAssessment'));
const CaseAnnotation = lazy(() => import('../pages/CaseAnnotation'));
const MAPortal = lazy(() => import('../portals/medaffairs/MAPortal'));
const ProcedureCounts = lazy(() => import('../pages/ProcedureCounts'));

const routeConfig = [
    {
        path: '/',
        component: Landing,
        protected: true,
    },
    {
        path: '/login',
        component: Login,
        protected: false,
    },
    {
        path: '/dashboard',
        component: Dashboard,
        protected: true,
    },
    {
        path: '/procedure-counts',
        component: ProcedureCounts,
        protected: true,
    },
    {
        path: '/dashboards',
        component: AceDashboards,
        protected: true,
    },
    {
        path: '/assessments/:id?/:uuid?',
        component: CaseAssessment,
        protected: true,
    },
    {
        path: '/summary/:tab?',
        component: ProcedureSummary,
        protected: true,
    },
    {
        path: '/search',
        component: Search,
        protected: true,
    },
    {
        path: '/performance',
        component: ProcedurePerformanceSearch,
        protected: true,
    },
    {
        path: '/clinicalsummary/:tab?',
        component: ClinicalReportSummary,
        protected: true,
    },
    {
        path: '/demo/procedure',
        component: ProcedureDemo,
        protected: true,
    },
    {
        path: '/:product/:page/:uuid',
        component: PageAppRedirect,
        protected: true,
    },
    {
        path: '/procedures/:uuid',
        component: ProcedureDetail,
        protected: true,
    },
    {
        path: '/esd/:uuid',
        component: ESDProcedureDetail,
        protected: true,
    },
    {
        path: '/demo/p',
        component: ProcedureCompactDemo,
        protected: true,
    },
    {
        path: '/p/:uuid',
        component: ProcedureCompact,
        protected: true,
    },
    {
        path: '/caq/:uuid',
        component: ProcedureCAQ,
        protected: true,
    },
    {
        path: '/annotation/:uuid',
        component: CaseAnnotation,
        protected: true,
    },
    {
        path: '/edit/:uuid',
        component: ProcedureTimelineEdit,
        protected: true,
    },
    {
        path: '/review/:uuid',
        component: PolypCountEdit,
        protected: true,
    },
    {
        path: '/perfedit/:uuid',
        component: PerformanceEdit,
        protected: true,
    },
    {
        path: '/patient/:uuid',
        component: GGPatientReport,
        protected: true,
    },
    {
        path: '/hospitals',
        component: HospitalDetail,
        protected: true,
    },
    {
        path: '/installations/:user?',
        component: InstallationDetail,
        protected: true,
    },
    {
        path: '/cat',
        component: CatUploadList,
        protected: true,
    },
    {
        path: '/about',
        component: About,
        protected: true,
    },
    {
        path: '/medaffairs',
        component: MAPortal,
        protected: true,
    },
    {
        path: '/settings',
        component: AccountSettings,
        protected: true,
    },
    {
        path: '/error/appForbidden',
        component: ForbiddenApp,
        protected: true,
    },
    {
        path: '*',
        component: NotFound,
        protected: false,
    },
];

export default routeConfig;
